import { IntegrationType } from "@/store/integrations/integrationsSlice";

type IntegrationSelectButtonOption = {
  type: IntegrationType;
  label: string;
};
export const integrationOptions: IntegrationSelectButtonOption[] = [
  {
    type: "jira",
    label: "Create Jira",
  },
  {
    type: "slack",
    label: "Send Slack",
  },
  {
    type: "email",
    label: "Send Email",
  },
];

export const oneDayInSeconds = 86400;
